import type { CSSObject } from '@emotion/styled'
import { Heading2, withCitrusTheme } from '@gousto-internal/citrus-react'

export const Title = withCitrusTheme(Heading2, (theme) => ({
  ...(theme.responsiveFont([6, null, 7, 10]) as CSSObject),
  maxWidth: '90%',
}))
